import { useEffect, useState } from 'react'

const VERSION_POLL_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

const fetchServerVersion = async (): Promise<string | null> => {
  try {
    const res = await fetch('/api')
    if (!res.ok) return null
    const data = (await res.json()) as { version?: unknown }
    return typeof data.version === 'string' ? data.version : null
  } catch {
    return null
  }
}

export const useAppVersionCheck = () => {
  const [isOutdated, setIsOutdated] = useState(false)

  useEffect(() => {
    if (new URLSearchParams(window.location.search).has('forceVersionBanner')) {
      setIsOutdated(true)
      return
    }

    const clientVersion = __APP_VERSION__

    if (clientVersion === 'dev') {
      return
    }

    let cancelled = false

    const check = async () => {
      const serverVersion = await fetchServerVersion()
      if (cancelled || !serverVersion || serverVersion === 'dev') return
      if (serverVersion !== clientVersion) {
        setIsOutdated(true)
      }
    }

    check()
    const interval = setInterval(check, VERSION_POLL_INTERVAL_MS)
    window.addEventListener('focus', check)

    return () => {
      cancelled = true
      clearInterval(interval)
      window.removeEventListener('focus', check)
    }
  }, [])

  return { isOutdated }
}
